import type {BankAccount} from '../types/contract';

export const emptyBankAccount = (): BankAccount => ({
    bankId: '',
    accountNumber: '',
    iban: '',
    accountHolder: '',
});

// Mirrors the backend normalisation (trim, blank iban/holder -> null, iban upper-cased).
// An employee has one account when created; a new account never carries an id.
export const toBankAccountPayload = (account?: BankAccount | null): BankAccount | undefined => {
    if (!account) return undefined;
    const iban = (account.iban ?? '').trim().toUpperCase();
    const holder = (account.accountHolder ?? '').trim();
    return {
        id: null,
        bankId: (account.bankId ?? '').trim(),
        accountNumber: (account.accountNumber ?? '').trim(),
        iban: iban || null,
        accountHolder: holder || null,
    };
};
